
function initSwiper() {
    const isMobile = window.innerWidth <= 768;
    const swiperContainer = document.querySelectorAll('[data-collection-container-tabs]');

    if(!swiperContainer || swiperContainer==null || swiperContainer.length==0){
        return;
    }
    
    swiperContainer.forEach(swiper_tabs => {
        const swipperTabs = swiper_tabs.querySelector('.collection-carousel__swiper_tabs');
        const swiperButtonPrev = swiper_tabs.querySelector('.swiper-button-prev');
        const swiperButtonNext = swiper_tabs.querySelector('.swiper-button-next');
        
        var swiper = new Swiper(swipperTabs, {
            slidesPerView: 'auto',
            centeredSlides: isMobile ? true : false,
            loop: isMobile ? true : false,
            spaceBetween: 30,
            pagination: isMobile ? {
            el: '.swiper-pagination',
            clickable: true,
        } : false,
        navigation: {
            nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev,
            },
        });
    });
}
function initTabsTitle(){
    const swiperContainer = document.querySelectorAll('.collection-carousel__swiper_tabs');

    if(!swiperContainer || swiperContainer==null || swiperContainer.length==0){
        return;
    }

    const tabsTitle = document.querySelectorAll('.collection-carousel_title-tabs');
    const tabsContainer = document.querySelectorAll('[data-collection-container-tabs]');
    tabsTitle.forEach(tabTitle => {
        tabTitle.addEventListener('click', function () {
            const idCollection = tabTitle.dataset.idCollection;
            tabsTitle.forEach(tabti => {
                tabti.classList.remove('collection-carousel_title-tabs--active');
                tabti.classList.add('collection-carousel_title-tabs--inactive');
            });
            tabTitle.classList.remove('collection-carousel_title-tabs--inactive');
            tabTitle.classList.add('collection-carousel_title-tabs--active');

            tabsContainer.forEach(tabContainer => {
                tabContainer.classList.remove('collection-carousel__tabs--active');
                if(tabContainer.dataset.idCollection == idCollection){
                    tabContainer.classList.remove('collection-carousel__tabs--inactive');
                    tabContainer.classList.add('collection-carousel__tabs--active');
                }else{
                    tabContainer.classList.remove('collection-carousel__tabs--active');
                    tabContainer.classList.add('collection-carousel__tabs--inactive');
                }
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initSwiper();
    initTabsTitle();
});
/* window.addEventListener('resize', function () {
    initSwiper();
}); */
